import React from "react";

import VideoComponent from "../Video";

function Video({ children }: { children: string }) {
  return (
    <picture className="w-full h-70 flex justify-center items-center">
      <div className="max-w-sm">
        <VideoComponent url={children} />
      </div>
    </picture>
  );
}

export default Video;
